(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-demo-text"] && !Shopify.designMode) return;
  try {
    // Fonts are registered per style as '{product title} {Font Style}'
  // (see snippets/font-loader.liquid)
  var fontSection = document.querySelector('[data-font-base]');
  var fontBase = fontSection ? fontSection.dataset.fontBase : '';
  var defaultStyle = fontSection ? fontSection.dataset.defaultStyle : '';
  var featGlyph = document.getElementById('featured-glyph');

  function familyForStyle(style) {
    return style ? fontBase + ' ' + style : fontBase;
  }

  // Clamps `value` to `input`'s min/max (if set) so a typed, pasted, or
  // spun-in number can never silently apply a broken style (e.g. negative
  // size, zero leading). Snaps the field itself back to the clamped value
  // so what's displayed always matches what's actually applied.
  function clampToInput(input, value) {
    if (!input) return value;
    if (input.min !== '' && value < parseFloat(input.min)) value = parseFloat(input.min);
    if (input.max !== '' && value > parseFloat(input.max)) value = parseFloat(input.max);
    return value;
  }

  // ── Mobile toolbar: one control open at a time ───────────────
  // Below `pc` the toolbar collapses to a row of icons (.toolbar-item in
  // input.css) and tapping one stretches its control open. Flex can't
  // size that control — a collapsed one still contributes its content
  // width to the row's intrinsic size — so the free space is measured
  // here and handed to Motion.animate, which moves the width between zero
  // and it. Measured from the toggles rather than the items
  // so the result doesn't depend on which control happens to be open.
  var toolbarIsMobile = window.matchMedia('(max-width: 1023px)');
  var toolbars = document.querySelectorAll('[data-toolbar-for]');

  function measureToolbar(bar) {
    var barStyle = getComputedStyle(bar);
    var gap = parseFloat(barStyle.columnGap) || 0;
    var room = bar.clientWidth - parseFloat(barStyle.paddingLeft) - parseFloat(barStyle.paddingRight);
    var slots = 0;

    Array.prototype.forEach.call(bar.children, function (child) {
      // The area label is absolutely positioned — out of flow, no gap.
      if (getComputedStyle(child).position === 'absolute') return;
      slots++;
      var toggle = child.querySelector ? child.querySelector('[data-toolbar-toggle]') : null;
      room -= toggle ? toggle.offsetWidth : child.offsetWidth;
    });

    // One gap between every pair of children, plus the one the open
    // control adds ahead of itself.
    room -= gap * slots;
    return Math.max(0, Math.floor(room));
  }

  function controlOf(item) {
    return item.querySelector('.toolbar-control');
  }

  // The width leg and a shorter opacity leg that waits a beat on the way in,
  // so the control reads as sliding out rather than being wiped in. Motion
  // takes a per-value option object for exactly that.
  function animateControl(control, open, openWidth) {
    if (open) control.style.visibility = 'visible';

    control.obAnimation = Motion.animate(
      control,
      { width: [control.offsetWidth + 'px', (open ? openWidth : 0) + 'px'], opacity: open ? 1 : 0 },
      {
        duration: 0.4,
        ease: Motion.easeStandard,
        opacity: { duration: 0.25, ease: Motion.easeStandard, delay: open ? 0.1 : 0 },
        // A collapsed control is zero-width but still focusable, so it leaves
        // the tab order once it has finished folding away.
        onComplete: function () {
          if (!open) control.style.visibility = 'hidden';
        },
      },
    );
  }

  // At `pc` the controls are laid out by CSS again, so the inline styles the
  // animation left behind have to go — and any animation still running with
  // them (stopping commits whatever it was mid-write).
  function clearControl(control) {
    if (control.obAnimation) control.obAnimation.stop();
    control.obAnimation = null;
    control.style.width = '';
    control.style.opacity = '';
    control.style.visibility = '';
  }

  // Each toolbar's "close everything" is kept here rather than hung off
  // the element, so the resize handler below can reach it.
  var closers = [];

  toolbars.forEach(function (bar) {
    var items = bar.querySelectorAll('[data-toolbar-item]');

    function closeAll() {
      items.forEach(function (item) {
        if (!item.classList.contains('is-open')) return;
        item.classList.remove('is-open');
        item.querySelector('[data-toolbar-toggle]').setAttribute('aria-expanded', 'false');
        animateControl(controlOf(item), false);
      });
    }

    // Past `pc` the controls are laid out by CSS again, so the inline
    // styles the animation leaves behind have to be dropped.
    function clearControls() {
      items.forEach(function (item) {
        clearControl(controlOf(item));
      });
    }

    closers.push({ bar: bar, closeAll: closeAll, clearControls: clearControls });

    // Reset puts the area back to its initial state (handler further
    // down), so leaving a control open on top of it would be claiming an
    // edit that no longer exists — it folds the row back to icons too.
    var reset = bar.querySelector('[data-toolbar-reset]');
    if (reset) reset.addEventListener('click', closeAll);

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-toolbar-toggle]');

      toggle.addEventListener('click', function () {
        if (!toolbarIsMobile.matches) return;
        var wasOpen = item.classList.contains('is-open');
        closeAll();
        if (wasOpen) return;
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        animateControl(controlOf(item), true, measureToolbar(bar));
      });
    });
  });

  // The open width is measured against the viewport, and at `pc` every
  // control is open regardless — so a resize either re-measures the open
  // control or, past the breakpoint, closes the row rather than leaving a
  // stale px width and a stale aria-expanded behind.
  window.addEventListener('resize', function () {
    closers.forEach(function (entry) {
      if (!toolbarIsMobile.matches) {
        entry.closeAll();
        entry.clearControls();
        return;
      }

      var open = entry.bar.querySelector('.toolbar-item.is-open');
      if (open) animateControl(controlOf(open), true, measureToolbar(entry.bar));
    });
  });

  // ── One toolbar per demo area ────────────────────────────────
  // Each area sits in its own [data-demo-group] wrapper alongside the
  // toolbar that drives it. Scoping everything to the group means the
  // controls only ever touch their own area, and it gives us a single
  // element to ask "has focus left this area and its toolbar?".
  document.querySelectorAll('[data-demo-area]').forEach(function (area) {
    var id = area.dataset.demoArea;
    var group = area.closest('[data-demo-group]');
    if (!group) return;

    var styleSelect = document.getElementById('toolbar-' + id + '-style');
    var sizeInput = document.getElementById('toolbar-' + id + '-size');
    var leadInput = document.getElementById('toolbar-' + id + '-leading');
    var trackInput = document.getElementById('toolbar-' + id + '-tracking');
    var resetButton = document.getElementById('toolbar-' + id + '-reset');

    function initialState() {
      return {
        size: parseFloat(area.dataset.initSize) || 200,
        leading: parseFloat(area.dataset.initLeading) || 1,
        tracking: parseFloat(area.dataset.initTracking) || 0,
        style: defaultStyle,
      };
    }

    var state = initialState();
    if (styleSelect) state.style = styleSelect.value;

    function syncInputs() {
      if (sizeInput) sizeInput.value = state.size;
      if (leadInput) leadInput.value = parseFloat(state.leading).toFixed(1);
      if (trackInput) trackInput.value = state.tracking;
      if (styleSelect && state.style) styleSelect.value = state.style;
    }

    function apply() {
      var style = styleSelect ? styleSelect.value : state.style;
      var size = sizeInput ? parseFloat(sizeInput.value) || state.size : state.size;
      var leading = leadInput ? parseFloat(leadInput.value) || state.leading : state.leading;
      var track = trackInput ? parseFloat(trackInput.value) || 0 : 0;

      size = clampToInput(sizeInput, size);
      leading = clampToInput(leadInput, leading);
      track = clampToInput(trackInput, track);

      if (sizeInput && parseFloat(sizeInput.value) !== size) sizeInput.value = size;
      if (leadInput && parseFloat(leadInput.value) !== leading) leadInput.value = leading.toFixed(1);
      if (trackInput && parseFloat(trackInput.value) !== track) trackInput.value = track;

      var family = familyForStyle(style);

      // Size is in px at the 1440px reference viewport — .demo-fluid
      // (input.css) scales it with the actual viewport width.
      area.style.setProperty('--demo-size', size);
      area.style.lineHeight = leading;
      area.style.letterSpacing = track + 'em';
      area.style.fontFamily = "'" + family + "'";

      if (featGlyph) featGlyph.style.fontFamily = "'" + family + "'";

      state = { size: size, leading: leading, tracking: track, style: style };
    }

    // Toolbars are always visible, so focus only tints the group to show
    // which area is being edited. Moving from the area straight into its
    // own toolbar must NOT drop the tint, so the untint only fires when
    // the incoming focus target is outside the group entirely.
    area.addEventListener('focus', function () {
      group.style.outline = '1px solid var(--color-grey-100)';
    });

    group.addEventListener('focusout', function (e) {
      var next = e.relatedTarget;
      if (next && group.contains(next)) return;
      group.style.outline = '';
    });

    if (styleSelect) styleSelect.addEventListener('change', apply);
    if (sizeInput) sizeInput.addEventListener('input', apply);
    if (leadInput) leadInput.addEventListener('input', apply);
    if (trackInput) trackInput.addEventListener('input', apply);

    // ── Reset ──────────────────────────────────────────────────
    // Restores this area's size/leading/tracking/style back to its
    // original data-init-* values (and the product's default style) —
    // the only way to undo a mistake was previously a full page reload,
    // which loses every other area's edits too.
    if (resetButton) {
      resetButton.addEventListener('click', function () {
        state = initialState();
        syncInputs();
        apply();
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-glyph-panel"] && !Shopify.designMode) return;
  try {
    // Fonts are registered per style as '{product title} {Font Style}'
  // (see snippets/font-loader.liquid)
  var fontSection = document.querySelector('[data-font-base]');
  var fontBase = fontSection ? fontSection.dataset.fontBase : '';

  function familyForStyle(style) {
    return style ? fontBase + ' ' + style : fontBase;
  }

  // ── Which characters a feature actually rewrites ─────────────
  // Highlighting "what changes" means resolving the feature's GSUB lookups
  // against the sample string rather than guessing: collect the subtables
  // the feature points at, then walk the glyph run marking the spans each
  // one would match. Ligature and chaining lookups are matched in context
  // — their coverage alone would light up every stray 'f' and 'i' — while
  // anything unrecognised falls back to marking coverage hits, which
  // over-selects rather than silently highlighting nothing.
  //
  // GPOS-only features (cpsp, kern) substitute nothing, so they get no
  // highlight: there is no glyph to point at, only spacing between them.

  // Coverage tables are the OpenType way of saying "these glyphs, in this
  // order" — the order matters because lookup types 4/5/6 index their rule
  // sets by the position within coverage, not by glyph id.
  function coverageIndex(cov, gid) {
    if (!cov || gid === undefined) return -1;
    if (cov.format === 1) return cov.glyphs.indexOf(gid);
    if (cov.format === 2) {
      for (var i = 0; i < cov.ranges.length; i++) {
        var r = cov.ranges[i];
        if (gid >= r.start && gid <= r.end) return r.index + gid - r.start;
      }
    }
    return -1;
  }

  // A feature can be listed once per script/language, so the same tag may
  // appear several times; type 7 is a wrapper holding the real subtable.
  function featureSubtables(table, tag) {
    var out = [];
    if (!table) return out;
    (table.features || []).forEach(function (record) {
      if (record.tag !== tag) return;
      (record.feature.lookupListIndexes || []).forEach(function (index) {
        var lookup = table.lookups[index];
        if (!lookup) return;
        (lookup.subtables || []).forEach(function (subtable) {
          if (lookup.lookupType === 7 && subtable.extension) {
            out.push({ type: subtable.lookupType, subtable: subtable.extension });
          } else {
            out.push({ type: lookup.lookupType, subtable: subtable });
          }
        });
      });
    });
    return out;
  }

  function glyphsMatch(gids, at, seq) {
    for (var i = 0; i < seq.length; i++) {
      if (gids[at + i] !== seq[i]) return false;
    }
    return true;
  }

  function coveragesMatch(gids, at, covs) {
    for (var i = 0; i < covs.length; i++) {
      if (coverageIndex(covs[i], gids[at + i]) < 0) return false;
    }
    return true;
  }

  // Backtrack sequences run away from the match, so entry i sits i+1
  // glyphs *before* it — reading them forwards is the classic way to get
  // contextual lookups subtly wrong.
  function backtrackMatches(gids, at, seq) {
    for (var i = 0; i < seq.length; i++) {
      if (gids[at - 1 - i] !== seq[i]) return false;
    }
    return true;
  }

  function backtrackCoveragesMatch(gids, at, covs) {
    for (var i = 0; i < covs.length; i++) {
      if (coverageIndex(covs[i], gids[at - 1 - i]) < 0) return false;
    }
    return true;
  }

  function matchSubtable(entry, gids, mark) {
    var st = entry.subtable;
    var type = entry.type;

    for (var i = 0; i < gids.length; i++) {
      // Format 3 keys off a list of coverages instead of a single one, so
      // it is matched before the coverage gate below rejects it.
      if (type === 6 && st.substFormat === 3) {
        var input3 = st.inputCoverage || [];
        if (
          input3.length &&
          coveragesMatch(gids, i, input3) &&
          backtrackCoveragesMatch(gids, i, st.backtrackCoverage || []) &&
          coveragesMatch(gids, i + input3.length, st.lookaheadCoverage || [])
        ) {
          mark(i, i + input3.length);
        }
        continue;
      }

      if (type === 5 && st.substFormat === 3) {
        var covs = st.coverages || [];
        if (covs.length && coveragesMatch(gids, i, covs)) mark(i, i + covs.length);
        continue;
      }

      var ci = coverageIndex(st.coverage, gids[i]);
      if (ci < 0) continue;

      // Ligatures: coverage holds the first component only, the rest of
      // the sequence has to follow for the substitution to happen.
      if (type === 4) {
        var ligatures = (st.ligatureSets || [])[ci] || [];
        for (var l = 0; l < ligatures.length; l++) {
          var components = ligatures[l].components || [];
          if (glyphsMatch(gids, i + 1, components)) {
            mark(i, i + 1 + components.length);
            break;
          }
        }
        continue;
      }

      if (type === 6 && st.substFormat === 1) {
        var chainRules = (st.chainRuleSets || [])[ci] || [];
        for (var c = 0; c < chainRules.length; c++) {
          var rule = chainRules[c];
          var input1 = rule.input || [];
          if (
            glyphsMatch(gids, i + 1, input1) &&
            backtrackMatches(gids, i, rule.backtrack || []) &&
            glyphsMatch(gids, i + 1 + input1.length, rule.lookahead || [])
          ) {
            mark(i, i + 1 + input1.length);
            break;
          }
        }
        continue;
      }

      if (type === 5 && st.substFormat === 1) {
        var seqRules = (st.ruleSets || [])[ci] || [];
        for (var s = 0; s < seqRules.length; s++) {
          var input5 = seqRules[s].input || [];
          if (glyphsMatch(gids, i + 1, input5)) {
            mark(i, i + 1 + input5.length);
            break;
          }
        }
        continue;
      }

      // Types 1-3 rewrite the covered glyph outright. Class-based context
      // (format 2) lands here too: matching it needs the class definitions
      // as well, so it settles for its first input glyph.
      mark(i, i + 1);
    }
  }

  // Returns [startOffset, endOffset] pairs in the string's own UTF-16
  // offsets, ready to hand to a DOM Range.
  function featureRanges(font, tag, text) {
    var entries = featureSubtables(font.tables.gsub, tag);
    if (!entries.length) return [];

    // Glyph ids are per code point; Range offsets are per code unit. The
    // samples are all BMP today, but keeping both indexes means an astral
    // character can never silently shift every highlight after it.
    var gids = [];
    var offsets = [];
    for (var at = 0; at < text.length;) {
      var ch = String.fromCodePoint(text.codePointAt(at));
      gids.push(font.charToGlyphIndex(ch));
      offsets.push(at);
      at += ch.length;
    }
    offsets.push(text.length);

    var hit = [];
    function mark(from, to) {
      for (var i = Math.max(0, from); i < to && i < gids.length; i++) hit[i] = true;
    }
    entries.forEach(function (entry) {
      matchSubtable(entry, gids, mark);
    });

    var ranges = [];
    var index = 0;
    while (index < gids.length) {
      if (!hit[index]) {
        index++;
        continue;
      }
      var start = index;
      while (index < gids.length && hit[index]) index++;
      ranges.push([offsets[start], offsets[index]]);
    }
    return ranges;
  }

  // ── Opentype.js glyph grid ───────────────────────────────────
  // font.file metafield is a list; #product-font-files-json maps
  // each Font Style to its .woff2 URL. The grid reloads when the
  // toolbar style changes.
  var fontFilesEl = document.getElementById('product-font-files-json');
  var fontFiles = {};
  try {
    fontFiles = fontFilesEl ? JSON.parse(fontFilesEl.textContent) : {};
  } catch (e) {
    console.error('[opentype] invalid font files JSON', e);
  }
  // file.url renders protocol-relative (//store.myshopify.com/...) which
  // resolves to http: on the local theme dev server — force https.
  Object.keys(fontFiles).forEach(function (key) {
    if (fontFiles[key].indexOf('//') === 0) fontFiles[key] = 'https:' + fontFiles[key];
  });
  var fontCache = {};
  var currentFontUrl = null;
  var currentGlyph = null;
  // Unicode of the click-pinned preview glyph (null = follow hover).
  // Lives outside renderGlyphGrid so the pin survives style switches.
  var pinnedUnicode = null;

  // ── Keep the metrics view laid out as its box changes ────────
  // Nearly all of the view scales itself: the metric lines sit at fixed
  // fractions of the box and the glyph rides a nested viewBox, so a resize
  // costs nothing. The three sidebearing numbers are the exception — their
  // size is fixed while the span they label scales — so they're repositioned
  // here. That's three `x` attributes, cheap enough to do on every
  // observation, which is what the panel's easing height asks for.
  // layoutMetricSpans is rebuilt per font, so keep a pointer to the current
  // one rather than observing from inside renderGlyphGrid, which would stack
  // up an observer per style switch.
  var layoutMetricSpans = null;
  var metricsContainer = document.getElementById('metrics-view-container');

  if (metricsContainer && typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(function (entries) {
      var box = entries[0].contentRect;
      if (layoutMetricSpans) layoutMetricSpans(box.width, box.height);
    }).observe(metricsContainer);
  }

  var copyRow = document.getElementById('copy-glyph-row');
  if (copyRow) {
    copyRow.addEventListener('click', function () {
      if (currentGlyph && navigator.clipboard) {
        navigator.clipboard.writeText(String.fromCodePoint(currentGlyph.unicode));
      }
    });
  }

  function glyphFontUrl(style) {
    if (fontFiles[style]) return fontFiles[style];
    var keys = Object.keys(fontFiles);
    return keys.length ? fontFiles[keys[0]] : null;
  }

  // opentype.js cannot parse WOFF2 on its own — lazy-load the wawoff2
  // (Brotli) decompressor and convert to TTF bytes first.
  var woff2Promise = null;
  function ensureWoff2() {
    if (!woff2Promise) {
      woff2Promise = new Promise(function (resolve, reject) {
        if (window.Module && window.Module.decompress) return resolve();
        window.Module = { onRuntimeInitialized: resolve };
        var s = document.createElement('script');
        s.src = 'https://unpkg.com/wawoff2@2.0.1/build/decompress_binding.js';
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return woff2Promise;
  }

  function parseFontBuffer(buffer) {
    var bytes = new Uint8Array(buffer);
    // 'wOF2' magic number
    var isWoff2 = bytes[0] === 0x77 && bytes[1] === 0x4f && bytes[2] === 0x46 && bytes[3] === 0x32;
    if (!isWoff2) return opentype.parse(buffer);
    return ensureWoff2().then(function () {
      var ttf = window.Module.decompress(bytes);
      return opentype.parse(new Uint8Array(ttf).buffer);
    });
  }

  function loadGlyphFont(style) {
    var url = glyphFontUrl(style);
    if (!url) {
      console.warn('[opentype] no font file for style:', style);
      return;
    }
    if (url === currentFontUrl) return;
    if (typeof opentype === 'undefined') {
      setTimeout(function () {
        loadGlyphFont(style);
      }, 200);
      return;
    }
    currentFontUrl = url;

    if (!fontCache[url]) {
      fontCache[url] = fetch(url)
        .then(function (res) {
          return res.arrayBuffer();
        })
        .then(parseFontBuffer);
    }

    fontCache[url]
      .then(function (font) {
        if (currentFontUrl !== url) return; // a newer style was selected meanwhile
        renderGlyphGrid(font, familyForStyle(style));
      })
      .catch(function (err) {
        console.error('[opentype] load error:', err);
        delete fontCache[url];
        if (currentFontUrl === url) currentFontUrl = null;
      });
  }

  function renderGlyphGrid(font, glyphFamily) {
    var grid = document.getElementById('glyph-grid');
    if (!grid) return;
    grid.innerHTML = '';

    var allCells = [];

    // ── MetricsView ─────────────────────────────────────
    // Everything here is expressed so the browser does the scaling, because
    // the box eases to a new height every time the header hides.
    //
    // The horizontal metrics sit at a fixed fraction of the box — the old
    // unitToY(u) divided by H has no H left in it — so they are percentages,
    // built once, and never touched again. The glyph and the vertical guides
    // go inside a nested <svg> whose viewBox is in font units: `xMidYMid
    // meet` then reproduces exactly what used to be computed by hand, the
    // fitted scale standing in for glyphScale and the centring for x. Only
    // the sidebearing numbers need arithmetic on resize, and only because
    // their size stays put while the spans they label scale.
    var SVG_NS = 'http://www.w3.org/2000/svg';
    var container = document.getElementById('metrics-view-container');
    var linesGroup = document.getElementById('metric-lines');
    var guidesGroup = document.getElementById('glyph-guides');
    var spansGroup = document.getElementById('glyph-spans');
    var glyphPathEl = document.getElementById('glyph-path');
    var guidesView = document.getElementById('glyph-guides-view');
    var pathView = document.getElementById('glyph-path-view');

    var os2 = font.tables.os2 || {};
    var ascender = os2.sTypoAscender || font.ascender;
    var descender = os2.sTypoDescender || font.descender;
    var capHeight = os2.sCapHeight || Math.round(ascender * 0.72);
    var xHeight = os2.sxHeight || Math.round(ascender * 0.52);
    var upm = font.unitsPerEm;

    var METRIC_LINES = [
      { label: 'typo ascender', value: ascender, color: '#bbb' },
      { label: 'cap height', value: capHeight, color: '#bbb' },
      { label: 'x-height', value: xHeight, color: '#bbb' },
      { label: 'baseline', value: 0, color: '#00a1ff' },
      { label: 'typo descender', value: descender, color: '#bbb' },
    ];

    // The glyph is drawn into the middle 70% of the box, so the viewBox
    // carries the padding as font units either side of the em.
    var GLYPH_PAD = 0.15;
    var INK = 1 - GLYPH_PAD * 2;
    var totalUnits = ascender - descender;
    var padUnits = (totalUnits * GLYPH_PAD) / INK;
    var viewTop = -ascender - padUnits;
    var viewHeight = totalUnits + padUnits * 2;

    // Labels hang this far above whatever they annotate. The canvas drew
    // them with textBaseline 'bottom' and svg positions text by its
    // alphabetic baseline, so the descent comes off the gap too, or the
    // labels would sit down on their own lines.
    var LABEL_DY = -(2 + 8 * 0.2);

    function svg(name, attrs) {
      var node = document.createElementNS(SVG_NS, name);
      for (var key in attrs) node.setAttribute(key, attrs[key]);
      return node;
    }

    if (linesGroup) {
      linesGroup.textContent = '';
      METRIC_LINES.forEach(function (m) {
        var y = ((GLYPH_PAD + ((ascender - m.value) * INK) / totalUnits) * 100).toFixed(4) + '%';

        linesGroup.appendChild(svg('line', { x1: 0, y1: y, x2: '100%', y2: y, stroke: m.color }));

        // Labels hang just above their line, the name at the left edge and
        // the number at the right.
        var name = svg('text', { x: 0, y: y, dy: LABEL_DY, fill: m.color });
        name.textContent = m.label;
        linesGroup.appendChild(name);

        var value = svg('text', { x: '100%', y: y, dy: LABEL_DY, fill: m.color, 'text-anchor': 'end' });
        value.textContent = String(m.value);
        linesGroup.appendChild(value);
      });
    }

    // One entry per sidebearing number: the span it labels in font units,
    // and its own width, measured once here because it only changes with the
    // glyph. Laying them out on resize is then pure arithmetic.
    var spans = [];
    var spanUnits = 1;

    function layoutSpans(W, H) {
      if (!W || !H) return;

      // The same fit the nested <svg> is doing, so the numbers land on the
      // guides rather than near them.
      var scale = Math.min(W / spanUnits, (H * INK) / totalUnits);
      var originX = (W - spanUnits * scale) / 2;

      spans.forEach(function (span) {
        var left = originX + span.from * scale;
        var right = originX + span.to * scale;

        // A number sits centred in its span, but a tight sidebearing has no
        // room for one — those fall outside the pair of lines instead.
        if (span.width + 4 <= right - left) {
          span.node.setAttribute('x', (left + right) / 2);
          span.node.setAttribute('text-anchor', 'middle');
        } else if (span.overflow === 'left') {
          span.node.setAttribute('x', left - 3);
          span.node.setAttribute('text-anchor', 'end');
        } else {
          span.node.setAttribute('x', right + 3);
          span.node.setAttribute('text-anchor', 'start');
        }
      });
    }

    // Both draw into the nested viewBox's font units, so neither has to know
    // anything about the size of the box on screen.
    function guide(unitX, dashed) {
      guidesGroup.appendChild(
        svg('line', {
          x1: unitX,
          y1: viewTop,
          x2: unitX,
          y2: viewTop + viewHeight,
          stroke: dashed ? '#ddd' : '#bbb',
          'stroke-dasharray': dashed ? '2 2' : 'none',
          'vector-effect': 'non-scaling-stroke',
        }),
      );
    }

    function span(text, from, to, overflow) {
      var node = svg('text', { y: '100%', dy: LABEL_DY, fill: '#bbb' });
      node.textContent = text;
      spansGroup.appendChild(node);
      spans.push({
        node: node,
        from: from,
        to: to,
        overflow: overflow,
        // Falls back to a rough digit width if the panel isn't rendered yet
        // and the measurement comes back empty.
        width: node.getComputedTextLength() || text.length * 4.5,
      });
    }

    function renderPreview(glyph) {
      currentGlyph = glyph;
      if (!glyphPathEl || !glyph) return;

      // A zero-advance glyph would divide the fit by nothing; one unit wide
      // leaves the fit on the height, which is where it belongs anyway.
      var advance = Math.max(glyph.advanceWidth || 0, 1);
      var viewBox = [0, viewTop, advance, viewHeight].join(' ');
      guidesView.setAttribute('viewBox', viewBox);
      pathView.setAttribute('viewBox', viewBox);
      spanUnits = advance;

      // getPath at a font size of one em hands back the outline in font
      // units with the baseline at zero — the viewBox's own coordinates.
      glyphPathEl.setAttribute('d', glyph.unicode ? glyph.getPath(0, 0, upm).toPathData(2) : '');

      guidesGroup.textContent = '';
      spansGroup.textContent = '';
      spans = [];

      if (glyph.unicode) {
        // The solid lines are the glyph's origin and advance, so the span
        // between them is the full advance width, sidebearings included; the
        // dashed lines are the ink bounds, and the gaps either side of them
        // are the LSB and RSB. Drawing only the ink bounds (as this did)
        // left the sidebearings invisible.
        guide(0, false);
        guide(advance, false);

        var gm = glyph.getMetrics();
        if (isFinite(gm.xMin) && isFinite(gm.xMax) && gm.xMax > gm.xMin) {
          guide(gm.xMin, true);
          guide(gm.xMax, true);

          span(String(Math.round(gm.xMin)), 0, gm.xMin, 'left');
          span(String(Math.round(gm.xMax - gm.xMin)), gm.xMin, gm.xMax, 'right');
          span(String(Math.round((glyph.advanceWidth || 0) - gm.xMax)), gm.xMax, advance, 'right');
        } else {
          // Blank glyph (space and friends): only the advance says anything.
          span(String(Math.round(glyph.advanceWidth || 0)), 0, advance, 'right');
        }
      }

      if (container) layoutSpans(container.offsetWidth, container.offsetHeight);

      // GlyphInfo
      var uni = glyph.unicode;
      var ch = String.fromCodePoint(uni);
      var hex = uni.toString(16).toUpperCase().padStart(4, '0');
      var el = function (id) {
        return document.getElementById(id);
      };
      var n;
      n = el('info-name');
      if (n) n.textContent = glyph.name || ch;
      n = el('info-decimal');
      if (n) n.textContent = String(uni);
      n = el('info-hex');
      if (n) n.textContent = hex;
      n = el('info-html');
      if (n) n.textContent = '&#x' + hex + ';';
      n = el('info-copy');
      if (n) n.textContent = ch;
    }

    // Hand the resize observer this font's span layout.
    layoutMetricSpans = layoutSpans;

    // ── Unicode block grouping ──────────────────────────
    var BLOCKS = [
      { label: 'Basic Latin', start: 0x0000, end: 0x007f },
      { label: 'Latin-1 Supplement', start: 0x0080, end: 0x00ff },
      { label: 'Latin Extended-A', start: 0x0100, end: 0x017f },
      { label: 'Latin Extended-B', start: 0x0180, end: 0x024f },
      { label: 'Spacing Modifier Letters', start: 0x02b0, end: 0x02ff },
      { label: 'General Punctuation', start: 0x2000, end: 0x206f },
      { label: 'Currency Symbols', start: 0x20a0, end: 0x20cf },
      { label: 'Letterlike Symbols', start: 0x2100, end: 0x214f },
      { label: 'Arrows', start: 0x2190, end: 0x21ff },
      { label: 'Mathematical Operators', start: 0x2200, end: 0x22ff },
      { label: 'Private Use Area', start: 0xe000, end: 0xf8ff },
    ];

    var buckets = {};
    BLOCKS.forEach(function (b) {
      buckets[b.label] = [];
    });
    var otherGlyphs = [];

    for (var i = 0; i < font.glyphs.length; i++) {
      var g = font.glyphs.get(i);
      if (!g.unicode) continue;
      var placed = false;
      for (var bi = 0; bi < BLOCKS.length; bi++) {
        if (g.unicode >= BLOCKS[bi].start && g.unicode <= BLOCKS[bi].end) {
          buckets[BLOCKS[bi].label].push(g);
          placed = true;
          break;
        }
      }
      if (!placed) otherGlyphs.push(g);
    }

    var firstGlyph = font.charToGlyph('A').unicode ? font.charToGlyph('A') : null;
    var pinnedGlyphObj = null;
    var pinnedCell = null;

    function setActiveCell(cell) {
      allCells.forEach(function (c) {
        c.classList.remove('glyph-cell--active');
      });
      cell.classList.add('glyph-cell--active');
    }

    function buildSection(label, glyphs) {
      if (!glyphs.length) return;

      var section = document.createElement('div');
      section.className = 'glyph-section';

      var header = document.createElement('div');
      header.className = 'glyph-section-header';
      header.innerHTML = '<p class="text-base" style="line-height:1;text-transform:lowercase;">' + label + '</p>';
      section.appendChild(header);

      var gridEl = document.createElement('div');
      gridEl.className = 'glyph-grid-inner';

      glyphs.forEach(function (glyph) {
        var ch = String.fromCodePoint(glyph.unicode);
        var hex = glyph.unicode.toString(16).toUpperCase().padStart(4, '0');

        var cell = document.createElement('div');
        cell.className = 'glyph-cell';
        cell.style.fontFamily = "'" + glyphFamily + "'";
        cell.innerHTML = '<p class="glyph-code">' + hex + '</p><p class="glyph-char">' + ch + '</p>';

        // Hover always previews (top priority); the active highlight
        // stays on the pinned cell — hovered cells get :hover styling
        cell.addEventListener('mouseenter', function () {
          if (pinnedUnicode === null) setActiveCell(cell);
          renderPreview(glyph);
        });

        // …and on leave the preview falls back to the pinned glyph
        cell.addEventListener('mouseleave', function () {
          if (!pinnedGlyphObj) return;
          renderPreview(pinnedGlyphObj);
        });

        // Click pins the fallback to this glyph; clicking it again unpins
        cell.addEventListener('click', function () {
          if (pinnedUnicode === glyph.unicode) {
            pinnedUnicode = null;
            pinnedGlyphObj = null;
            pinnedCell = null;
            return;
          }
          pinnedUnicode = glyph.unicode;
          pinnedGlyphObj = glyph;
          pinnedCell = cell;
          setActiveCell(cell);
          renderPreview(glyph);

          // Below pc, the preview panel sits above the grid and scrolls
          // out of view — jump back up to it so the tap has visible effect.
          // The panel carries a scroll-margin-top clearing the header, which
          // scrollIntoView honours, so it lands below the bar rather than
          // behind it. Measured against --header-height, not --sticky-top:
          // the header is the only bar still pinned at this breakpoint, and
          // scrolling up here always brings it back on screen.
          if (!window.matchMedia('(min-width: 1024px)').matches) {
            var previewPanel = document.getElementById('glyph-preview-panel');
            if (previewPanel) previewPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });

        // Restore the pin after a grid rebuild (style switch)
        if (pinnedUnicode !== null && glyph.unicode === pinnedUnicode) {
          pinnedGlyphObj = glyph;
          pinnedCell = cell;
        }

        if (!firstGlyph) firstGlyph = glyph;
        allCells.push(cell);
        gridEl.appendChild(cell);
      });

      section.appendChild(gridEl);
      grid.appendChild(section);
    }

    BLOCKS.forEach(function (b) {
      buildSection(b.label, buckets[b.label]);
    });
    if (otherGlyphs.length) buildSection('Other', otherGlyphs);

    if (pinnedGlyphObj) {
      setActiveCell(pinnedCell);
      renderPreview(pinnedGlyphObj);
    } else {
      pinnedUnicode = null; // pinned glyph absent in this font — unpin
      if (firstGlyph) renderPreview(firstGlyph);
    }

    // ── OpenType features (reset per font) ──────────────
    // The rows themselves come from the 'Opentype Features' metaobject
    // (see 'product-opentype-features'); all this does is decide which of
    // them the parsed font really carries. Tags live in two tables —
    // GSUB for substitutions (liga, ss01, frac…) and GPOS for positioning
    // (cpsp, kern) — so a GSUB-only read would hide half the list.
    var featSection = document.getElementById('ot-features-section');
    var featContainer = document.getElementById('ot-features');
    if (featSection && featContainer) {
      var tags = {};
      ['gsub', 'gpos'].forEach(function (table) {
        var features = (font.tables[table] && font.tables[table].features) || [];
        features.forEach(function (f) {
          tags[f.tag] = true;
        });
      });

      // The Custom Highlight API paints ranges without wrapping them in
      // elements. That matters here: a <span> around the matched
      // characters would split the shaping run, and the run is exactly the
      // context a ligature or contextual alternate needs to fire — the
      // highlight would destroy what it is pointing at. Where it isn't
      // supported the rows simply go unhighlighted.
      var canHighlight = typeof CSS !== 'undefined' && CSS.highlights && typeof Highlight === 'function';
      var highlight = canHighlight ? new Highlight() : null;

      var shown = 0;
      featContainer.querySelectorAll('[data-ot-tag]').forEach(function (row) {
        if (!tags[row.dataset.otTag]) {
          row.removeAttribute('data-ot-available');
          // A style switch can drop a feature the previous style had — a
          // toggle left on would carry into a font that no longer answers
          // to it, and come back set if the style returns.
          var input = row.querySelector('input[type="checkbox"]');
          if (input) input.checked = false;
          return;
        }

        row.setAttribute('data-ot-available', '');
        shown++;

        if (!highlight) return;
        var sample = row.querySelector('[data-ot-sample]');
        var textNode = sample && sample.firstChild;
        if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return;
        featureRanges(font, row.dataset.otTag, textNode.data).forEach(function (offsets) {
          var range = document.createRange();
          range.setStart(textNode, offsets[0]);
          range.setEnd(textNode, offsets[1]);
          highlight.add(range);
        });
      });

      // Rebuilt wholesale per font: the ranges belong to the style whose
      // lookups produced them, so carrying any of them over would mark
      // characters the new style leaves alone.
      if (canHighlight) {
        if (highlight.size) {
          CSS.highlights.set('ot-changed', highlight);
        } else {
          CSS.highlights.delete('ot-changed');
        }
      }

      // The samples show the same style the grid does: the tag list was
      // read off that font file, so any other style could contradict it.
      featContainer.style.fontFamily = "'" + glyphFamily + "'";
      featSection.classList.toggle('hidden', shown === 0);
    }
  }

  // Deliberately independent of the demo-text toolbar's #toolbar-style —
  // switching a specimen's style shouldn't also change the glyph grid.
  var glyphStyleRadios = document.querySelectorAll('input[name="glyph-style"]');
  function checkedGlyphStyle() {
    var checked = document.querySelector('input[name="glyph-style"]:checked');
    return checked ? checked.value : '';
  }
  glyphStyleRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      loadGlyphFont(radio.value);
    });
  });

  loadGlyphFont(checkedGlyphStyle());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-trial-modal"] && !Shopify.designMode) return;
  try {
    // ── Trial font download modal ──────────────────────────────────
  var trialModal = document.getElementById('trial-modal');
  var trialModalPanel = document.getElementById('trial-modal-panel');
  var openTrialBtn = document.getElementById('open-trial-modal');
  var closeTrialBtn = document.getElementById('close-trial-modal');
  var trialBackdrop = document.getElementById('trial-modal-backdrop');
  var trialAgreeLabel = document.getElementById('trial-agree-label');
  var trialAgreeCb = document.getElementById('trial-agree-checkbox');
  var trialAgreeCheck = document.getElementById('trial-agree-check');
  var trialDownloadBtn = document.getElementById('trial-download-btn');
  var trialAgreeError = document.getElementById('trial-agree-error');

  // The panel scales in, and leaving it just fades where it stands — which
  // reads faster than shrinking back down. Opacity steps rather than fades;
  // the scale underneath keeps the theme curve. Tracked with a flag because
  // `hidden` only goes back on once the dim has finished.
  var trialOpen = false;

  function openTrialModal() {
    trialOpen = true;
    // Reopening starts a fresh attempt — an error from the last one shouldn't
    // still be standing when the panel comes back.
    setTrialError(false);
    trialModal.classList.remove('hidden');
    Motion.animate(trialBackdrop, { opacity: [0, 1] }, { duration: 0.2 });
    Motion.animate(
      trialModalPanel,
      { opacity: 1, scale: [0.95, 1] },
      { duration: 0.4, ease: Motion.easeStandard, opacity: { ease: Motion.steps(1, 'start') } },
    );
  }

  function closeTrialModal() {
    if (!trialOpen) return;
    trialOpen = false;
    Motion.animate(trialModalPanel, { opacity: 0 }, { duration: 0.4, ease: Motion.steps(1, 'start') });
    // Hiding is left to the dim, the longer of the two: cutting it at the
    // panel's fade would chop the tail off the backdrop.
    Motion.animate(trialBackdrop, { opacity: 0 }, { duration: 0.2, onComplete: hideTrialModal });
  }

  function hideTrialModal() {
    if (trialOpen) return; // re-opened while the dim was still fading
    trialModal.classList.add('hidden');
  }

  if (openTrialBtn) openTrialBtn.addEventListener('click', openTrialModal);
  if (closeTrialBtn) closeTrialBtn.addEventListener('click', closeTrialModal);
  if (trialBackdrop) trialBackdrop.addEventListener('click', closeTrialModal);

  function setTrialError(show) {
    if (trialAgreeError) trialAgreeError.classList.toggle('hidden', !show);
  }

  if (trialAgreeLabel) {
    trialAgreeLabel.addEventListener('click', function (e) {
      // Let the licence link inside the label open instead of toggling the
      // checkbox.
      if (e.target.closest('a')) return;

      e.preventDefault();
      trialAgreeCb.checked = !trialAgreeCb.checked;
      if (trialAgreeCheck) trialAgreeCheck.classList.toggle('hidden', !trialAgreeCb.checked);
      // Only ever clears: the error is raised by the download button, so
      // unchecking again shouldn't put it back before they've asked.
      if (trialAgreeCb.checked) setTrialError(false);
    });
  }

  if (trialDownloadBtn) {
    trialDownloadBtn.addEventListener('click', function () {
      if (!trialAgreeCb || !trialAgreeCb.checked) {
        setTrialError(true);
        return;
      }
      setTrialError(false);
      var url = trialModal ? trialModal.dataset.trialUrl : '';
      closeTrialModal();
      if (url) window.location.href = url;
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-typeface-modal"] && !Shopify.designMode) return;
  try {
    // ── Modal open / close ───────────────────────────────────────
  var modal = document.getElementById('typeface-modal');
  var modalPanel = document.getElementById('typeface-modal-panel');
  var openBtn = document.getElementById('open-typeface-modal');
  var closeBtn = document.getElementById('close-typeface-modal');
  var backdrop = document.getElementById('modal-backdrop');
  // The panel scales in, and leaving it just fades where it stands — which
  // reads faster than shrinking back down. Opacity steps rather than fades;
  // the scale underneath keeps the theme curve. Tracked with a flag because
  // `hidden` only goes back on once the dim has finished.
  var modalOpen = false;

  function openModal() {
    modalOpen = true;
    // Reopening starts a fresh attempt — errors from the last one shouldn't
    // still be standing when the panel comes back.
    setFieldError(styleError, false);
    setFieldError(licenseError, false);
    modal.classList.remove('hidden');
    Motion.animate(backdrop, { opacity: [0, 1] }, { duration: 0.2 });
    Motion.animate(
      modalPanel,
      { opacity: 1, scale: [0.95, 1] },
      { duration: 0.4, ease: Motion.easeStandard, opacity: { ease: Motion.steps(1, 'start') } },
    );
  }

  function closeModal() {
    if (!modalOpen) return;
    modalOpen = false;
    Motion.animate(modalPanel, { opacity: 0 }, { duration: 0.4, ease: Motion.steps(1, 'start') });
    // The dim is what decides when the modal is hidden, so its fade carries
    // the callback.
    Motion.animate(backdrop, { opacity: 0 }, { duration: 0.2, onComplete: hideModal });
  }

  function hideModal() {
    if (modalOpen) return; // re-opened while the dim was still fading
    modal.classList.add('hidden');
  }

  if (openBtn) openBtn.addEventListener('click', openModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (backdrop) backdrop.addEventListener('click', closeModal);

  // ── Modal state ──────────────────────────────────────────────
  var variantsEl = document.getElementById('product-variants-json');
  var teamValuesEl = document.getElementById('product-team-values-json');
  var variantIdEl = document.getElementById('modal-variant-id');

  var subtotalEl = document.getElementById('modal-subtotal');

  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var teamValues = teamValuesEl ? JSON.parse(teamValuesEl.textContent) : [];
  var teamIdx = 0;

  // Custom checkbox toggle helper
  function toggleCheckUI(checkbox) {
    var isChecked = checkbox.checked;
    var mark = checkbox
      .closest('label')
      .querySelector('.style-check, .license-check, #full-family-check, #all-license-check');
    if (mark) mark.classList.toggle('hidden', !isChecked);
  }

  // ── Style checkboxes ─────────────────────────────────────────
  var styleCheckboxes = document.querySelectorAll('.style-checkbox');
  var fullFamilyCb = document.getElementById('full-family-checkbox');
  var fullFamilyCheck = document.getElementById('full-family-check');

  function setFullFamilyUI(checked) {
    if (fullFamilyCb) fullFamilyCb.checked = checked;
    if (fullFamilyCheck) fullFamilyCheck.classList.toggle('hidden', !checked);
  }

  function setAllStyles(checked) {
    styleCheckboxes.forEach(function (cb) {
      cb.checked = checked;
      toggleCheckUI(cb);
    });
  }

  function syncFullFamilyState() {
    var allChecked =
      styleCheckboxes.length > 0 &&
      Array.from(styleCheckboxes).every(function (cb) {
        return cb.checked;
      });
    setFullFamilyUI(allChecked);
  }

  if (fullFamilyCb) {
    fullFamilyCb.closest('label').addEventListener('click', function (e) {
      e.preventDefault();
      var next = !fullFamilyCb.checked;
      setFullFamilyUI(next);
      setAllStyles(next);
      updateSubtotal();
      updateVariantId();
    });
  }

  styleCheckboxes.forEach(function (cb) {
    cb.closest('label').addEventListener('click', function (e) {
      e.preventDefault();
      cb.checked = !cb.checked;
      toggleCheckUI(cb);
      syncFullFamilyState();
      updateSubtotal();
      updateVariantId();
    });
  });

  // ── License checkboxes ───────────────────────────────────────
  // The licence picks the variant's third option — one license costs the
  // styles' base price, two cost twice it, and All License (all three)
  // three times. Those prices live in Shopify, not here.
  var licenseCheckboxes = document.querySelectorAll('.license-checkbox');
  var licensePriceEls = document.querySelectorAll('.license-price');
  var allLicenseCb = document.getElementById('all-license-checkbox');
  var allLicenseCheck = document.getElementById('all-license-check');
  var allLicensePriceEl = document.getElementById('all-license-price');

  licenseCheckboxes.forEach(function (cb) {
    cb.closest('label').addEventListener('click', function (e) {
      e.preventDefault();
      cb.checked = !cb.checked;
      toggleCheckUI(cb);
      syncAllLicenseState();
      updateSubtotal();
      updateVariantId();
    });
  });

  function setAllLicenseUI(checked) {
    if (allLicenseCb) allLicenseCb.checked = checked;
    if (allLicenseCheck) allLicenseCheck.classList.toggle('hidden', !checked);
  }

  function setEveryLicense(checked) {
    licenseCheckboxes.forEach(function (cb) {
      cb.checked = checked;
      toggleCheckUI(cb);
    });
  }

  function syncAllLicenseState() {
    setAllLicenseUI(
      licenseCheckboxes.length > 0 &&
        Array.from(licenseCheckboxes).every(function (cb) {
          return cb.checked;
        }),
    );
  }

  if (allLicenseCb) {
    allLicenseCb.closest('label').addEventListener('click', function (e) {
      e.preventDefault();
      var next = !allLicenseCb.checked;
      setAllLicenseUI(next);
      setEveryLicense(next);
      updateSubtotal();
      updateVariantId();
    });
  }

  function checkedLicenses() {
    var checked = [];
    licenseCheckboxes.forEach(function (cb) {
      if (cb.checked) checked.push(cb.value);
    });
    return checked;
  }

  // The chosen licences name a variant, not a line item property: the checkbox
  // order is the option order in Shopify ('Web + Digital', never
  // 'Digital + Web'), and all three are sold as the 'All License' value.
  function licenseOption(licenses) {
    if (!licenses.length) return '';
    if (licenses.length === licenseCheckboxes.length) return 'All License';
    return licenses.join(' + ');
  }

  // ── Variant lookup ───────────────────────────────────────────
  // Style matching ignores case: the Full Family row passes a hardcoded
  // 'Full Family' while a product may spell its option value 'Full family'.
  function findVariant(style, license) {
    if (!style || !license) return null;
    var team = teamValues[teamIdx] || '';
    var wanted = style.toLowerCase();
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.style.toLowerCase() === wanted && v.team === team && v.license === license) return v;
    }
    return null;
  }

  function selectedStyles() {
    if (fullFamilyCb && fullFamilyCb.checked) return ['Full Family'];
    var styles = [];
    styleCheckboxes.forEach(function (cb) {
      if (cb.checked) styles.push(cb.dataset.style || '');
    });
    return styles;
  }

  function updateVariantId() {
    var variant = findVariant(selectedStyles()[0], licenseOption(checkedLicenses()));
    if (variant && variantIdEl) variantIdEl.value = variant.id;
  }

  // ── Required selections ──────────────────────────────────────
  // The add button stays clickable on an empty selection: a locked button
  // leaves the customer guessing which fieldset it is waiting on, so the
  // click is what names the missing one.
  var styleError = document.getElementById('style-error');
  var licenseError = document.getElementById('license-error');

  function setFieldError(el, show) {
    if (el) el.classList.toggle('hidden', !show);
  }

  function validateSelection() {
    var hasStyle = selectedStyles().length > 0;
    var hasLicense = checkedLicenses().length > 0;
    setFieldError(styleError, !hasStyle);
    setFieldError(licenseError, !hasLicense);
    return hasStyle && hasLicense;
  }

  // Only ever clears. An error is raised by an add attempt, so unchecking the
  // last box shouldn't put one back before the customer has asked again.
  function clearResolvedErrors() {
    if (selectedStyles().length > 0) setFieldError(styleError, false);
    if (checkedLicenses().length > 0) setFieldError(licenseError, false);
  }

  // ── Subtotal ─────────────────────────────────────────────────
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('ko-KR', { style: 'currency', currency: 'KRW' });
  }

  // Every figure in the modal is read off the variants themselves rather than
  // multiplied out here, so what the modal quotes is what Shopify charges.
  function totalFor(license) {
    var total = 0;
    selectedStyles().forEach(function (style) {
      var variant = findVariant(style, license);
      if (variant) total += variant.price;
    });
    return total;
  }

  function updateSubtotal() {
    var total = totalFor(licenseOption(checkedLicenses()));

    // Every path that changes the selection lands here, so this is where a
    // standing error learns it has been answered.
    clearResolvedErrors();

    // Each row quotes what that one license costs for the styles picked so far.
    licensePriceEls.forEach(function (el, i) {
      var rowTotal = licenseCheckboxes[i] ? totalFor(licenseCheckboxes[i].value) : 0;
      el.textContent = rowTotal > 0 ? '+ ' + formatMoney(rowTotal) : '—';
    });
    if (allLicensePriceEl) {
      var allLicenseTotal = totalFor('All License');
      allLicensePriceEl.textContent = allLicenseTotal > 0 ? formatMoney(allLicenseTotal) : '—';
    }
    if (subtotalEl) subtotalEl.textContent = total > 0 ? formatMoney(total) : '—';
  }

  updateSubtotal();

  // ── Cart add (one line per style) ────────────────────────────
  var cartForm = document.querySelector('#typeface-modal form');
  var submitBtn = cartForm ? cartForm.querySelector('[type="submit"]') : null;
  var submitIdleLabel = submitBtn ? submitBtn.textContent : '';

  function setAdding(next) {
    if (!submitBtn) return;
    submitBtn.disabled = next;
    submitBtn.setAttribute('aria-busy', next ? 'true' : 'false');
    submitBtn.textContent = next ? submitBtn.dataset.loadingLabel || submitIdleLabel : submitIdleLabel;
  }

  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!validateSelection()) return;

      var license = licenseOption(checkedLicenses());
      var styles = selectedStyles();

      // One line per style. The licences live in the variant, so a style bought
      // with all three arrives as a single line at three times the base price
      // rather than as three lines the customer has to read as one purchase.
      var items = [];
      styles.forEach(function (style) {
        var variant = findVariant(style, license);
        if (variant) items.push({ id: variant.id, quantity: 1 });
      });
      if (items.length === 0) return;

      setAdding(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer' }),
      })
        .then(function (r) {
          // /cart/add.js answers 422 with a JSON error body rather than
          // failing the fetch, so without this an out-of-stock add would end
          // the loading state and close the modal as if it had worked.
          if (!r.ok) throw new Error('cart/add ' + r.status);
          return r.json();
        })
        .then(function (response) {
          setAdding(false);
          closeModal();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function (err) {
          console.error('[cart/add]', err);
          // Back to whatever the current selection warrants, not blindly
          // enabled — the selection may well be empty by now.
          setAdding(false);
        });
    });
  }

  // ── Team count ───────────────────────────────────────────────
  var teamDisplay = document.getElementById('team-display');
  var teamMinus = document.getElementById('team-minus');
  var teamPlus = document.getElementById('team-plus');

  function updateTeam() {
    if (teamDisplay) teamDisplay.textContent = teamValues[teamIdx] + ' people' || '';
    updateVariantId();
    updateSubtotal();
  }

  if (teamMinus)
    teamMinus.addEventListener('click', function () {
      teamIdx = Math.max(0, teamIdx - 1);
      updateTeam();
    });
  if (teamPlus)
    teamPlus.addEventListener('click', function () {
      teamIdx = Math.min(teamValues.length - 1, teamIdx + 1);
      updateTeam();
    });
  } catch(e) { console.error(e); }
})();

})();
